import { ref, computed, watch } from 'vue';
const step = ref(1);
export function useStep() {
    const currentStep = computed(() => step.value);
    const setStep = (newStep) => {
        step.value = typeof newStep === 'string' ? parseInt(newStep) : newStep;
    };
    const nextStep = () => {
        step.value += 1;
    };
    const previousStep = () => {
        step.value = Math.max(1, step.value - 1);
    };
    const goToStep = (targetStep) => {
        setStep(targetStep);
    };
    const resetStep = () => {
        step.value = 1;
    };
    watch(step, () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    return {
        step: currentStep,
        currentStep,
        setStep,
        nextStep,
        previousStep,
        goToStep,
        resetStep
    };
}
